document.addEventListener('DOMContentLoaded', function () {
    $("[data-position='Your Dream Job']").click(function (event) {
        event.preventDefault();
        const position = $(this).attr("data-position");
        $("#role").val(position);
        $("#role").trigger("blur");
        $("body,html").animate({ scrollTop: $("#contact-us .section-title").offset().top - 100 }, 500);
        $("#fullname").focus();
    })
})
